import(/* webpackMode: "eager" */ "/vercel/path0/src/app/category/[id]/page.tsx");
